<template>
  <v-navigation-drawer app clipped right fixed permanent floating>
    <v-subheader>Contents</v-subheader>
    <v-list subheader dense class="contents">
      <v-list-item-group v-model="selected" mandatory>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :value="item.id"
          @click="navigate(item)"
          class="text-body-2 py-0"
          :class="`pl-${item.depth * 4}`"
        >
          {{ item.text }}
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "Contents",
  props: {
    items: { type: Array, required: true }
  },
  data() {
    return {
      selected: null
    }
  },
  methods: {
    navigate(item) {
      this.$vuetify.goTo(`#${item.id}`)
      this.$router.replace({ name: this.$route.name, hash: `#${item.id}` })
    }
  }
}
</script>
<style scoped>
.contents .v-list-item {
  border-left: medium solid #e0e0e0;
}
.contents .v-list-item--active {
  border-left: medium solid #2196f3;
}
</style>